import {
  CartQuoteActionTypes,
  CartUpdateActionTypes,
  CartUpdateServices,
  ParentState,
} from "@hopper-b2b/checkout";
import type { ChildMachineConfig } from "@hopper-b2b/checkout";

import { services as ApplyFeesServices } from "./services";
import { ApplyFeesState } from "./types";

export const getMachineState = (config: ChildMachineConfig) => ({
  id: ParentState.applyFees,
  initial: ApplyFeesState.route,
  states: {
    [ApplyFeesState.route]: {
      always: [
        {
          target: ApplyFeesState.addFees,
        },
      ],
    },
    [ApplyFeesState.addFees]: {
      invoke: {
        src: ApplyFeesServices.applyFees,
        onDone: {
          target: ApplyFeesState.getBreakdown,
        },
        onError: {
          actions: [
            (_context, event) => {
              console.error("Failed to apply fees:", event.data);
            },
          ],
          target: config.nextState,
        },
      },
    },
    [ApplyFeesState.getBreakdown]: {
      invoke: {
        src: CartUpdateServices.getQuoteBreakdownService,
        onDone: [
          {
            actions: [
              CartQuoteActionTypes.setCartBreakdown,
              CartUpdateActionTypes.setCartUpdateCallStateSuccess,
            ],
            target: config.nextState,
          },
        ],
        onError: {
          actions: [
            CartUpdateActionTypes.setCartUpdateError,
            CartUpdateActionTypes.setCartUpdateCallStateFailed,
          ],
          target: config.nextState,
        },
      },
    },
  },
});
